import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { useContext } from 'react';
import { viewBaseEvent } from '@chegg-me-components/utils';
import { rioClient } from '../../rio';
import { HeaderContext, isNavLinkItem, isNavLinkItemArray, useFlyOutMenuBehaviour, generateRioEventNavText } from '../../shared';
import { CenterNavSpanItem, FlyOutDropdown, FlyOutMenuContainer } from '../../styles/desktop';
import CenterNavMenuButton from '../desktop/desktopCenterNavMenuButton';
import { MultiMenu } from '../shared';
import MenuItemsList from '../shared/menuItemsList';
import CenterNavLink from './desktopCenterNavLink';

var FlyOutMenu = function FlyOutMenu(_ref) {
  var navMenu = _ref.navMenu,
      activeLink = _ref.activeLink,
      index = _ref.index,
      isActive = _ref.isActive,
      getActiveNavItem = _ref.getActiveNavItem,
      setActiveNavItem = _ref.setActiveNavItem,
      flyOutHoverOutDelayTimer = _ref.flyOutHoverOutDelayTimer;

  var _useFlyOutMenuBehavio = useFlyOutMenuBehaviour(index, isActive, getActiveNavItem, setActiveNavItem, flyOutHoverOutDelayTimer),
      flyOutMenuRef = _useFlyOutMenuBehavio.flyOutMenuRef,
      triggerButtonRef = _useFlyOutMenuBehavio.triggerButtonRef,
      toggleActiveState = _useFlyOutMenuBehavio.toggleActiveState,
      setActiveState = _useFlyOutMenuBehavio.setActiveState,
      unsetActiveState = _useFlyOutMenuBehavio.unsetActiveState,
      clearTimer = _useFlyOutMenuBehavio.clearTimer;

  var _useContext = useContext(HeaderContext),
      dataTestPrefix = _useContext.dataTestPrefix;

  return /*#__PURE__*/React.createElement(FlyOutMenuContainer, {
    "data-test": "".concat(dataTestPrefix, "-fly-out-menu-").concat(index),
    isActive: isActive,
    ref: flyOutMenuRef,
    onMouseEnter: function onMouseEnter() {
      rioClient.sendEvent(_objectSpread(_objectSpread({}, viewBaseEvent), {}, {
        data: {
          component_view: {
            component: {
              name: 'nav menu',
              type: 'drop down',
              region_name: "top nav|".concat(navMenu.parent.text),
              text: generateRioEventNavText(navMenu.children)
            },
            state: 'expanded'
          }
        }
      }));
      setActiveState();
    },
    onMouseLeave: function onMouseLeave(event) {
      return unsetActiveState(event);
    }
  }, isNavLinkItem(navMenu.parent) ? /*#__PURE__*/React.createElement(CenterNavLink, {
    index: index,
    isActive: isActive,
    navLink: navMenu.parent,
    activeLink: activeLink,
    hasSubmenu: true
  }) : /*#__PURE__*/React.createElement(CenterNavSpanItem, {
    "data-test": "".concat(dataTestPrefix, "-center-nav-span-").concat(index),
    "aria-haspopup": "true",
    "aria-expanded": isActive ? 'true' : 'false'
  }, navMenu.parent.text), /*#__PURE__*/React.createElement(CenterNavMenuButton, {
    index: index,
    ref: triggerButtonRef,
    navItemText: navMenu.parent.text,
    isActive: isActive,
    onClick: function onClick(event) {
      toggleActiveState();
      navMenu.onClickNavMenuButton && navMenu.onClickNavMenuButton(event);
    }
  }), /*#__PURE__*/React.createElement(FlyOutSubMenu, {
    isActive: isActive,
    index: index,
    subMenuLinks: navMenu.children,
    activeSubLink: activeLink === null || activeLink === void 0 ? void 0 : activeLink.child,
    clearTimer: clearTimer,
    unsetActiveState: unsetActiveState,
    breadcrumbs: [navMenu.parent.text]
  }));
};

var FlyOutSubMenu = function FlyOutSubMenu(_ref2) {
  var isActive = _ref2.isActive,
      index = _ref2.index,
      subMenuLinks = _ref2.subMenuLinks,
      activeSubLink = _ref2.activeSubLink,
      clearTimer = _ref2.clearTimer,
      unsetActiveState = _ref2.unsetActiveState,
      breadcrumbs = _ref2.breadcrumbs;

  var _useContext2 = useContext(HeaderContext),
      dataTestPrefix = _useContext2.dataTestPrefix;

  return /*#__PURE__*/React.createElement(FlyOutDropdown, {
    "data-test": "".concat(dataTestPrefix, "-fly-out-dropdown-").concat(index),
    isActive: isActive,
    onMouseDown: function onMouseDown(event) {
      /** clicking inside the dropdown would trigger blur; preventing this to not close the dropdown */

      /* istanbul ignore next */
      clearTimer();
      /* istanbul ignore next */

      event === null || event === void 0 ? void 0 : event.preventDefault();
    },
    onFocus:
    /* istanbul ignore next */
    clearTimer,
    onBlur: function onBlur(event) {
      /** defer the unset action until the focus remains inside dropdown */

      /* istanbul ignore next */
      unsetActiveState(event, 250);
    }
  },
  /* istanbul ignore next */
  isNavLinkItemArray(subMenuLinks) ? /*#__PURE__*/React.createElement(MenuItemsList, {
    listIndex: index,
    itemsList: subMenuLinks,
    activeItem: activeSubLink,
    breadcrumbs: breadcrumbs
  }) : /*#__PURE__*/React.createElement(MultiMenu, {
    multiMenuIndex: index,
    menuItems: subMenuLinks,
    activeItem: activeSubLink,
    breadcrumbs: breadcrumbs
  }));
};

FlyOutMenu.displayName = 'DesktopFlyOutMenu';
export default FlyOutMenu;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-me-components/signed-out-header/dist/esm/components/desktop/desktopFlyOutMenu.js
// module id = 5630
// module chunks = 11